<template>
  <div class="guarantee-content-tab">
    <!-- 搜索栏 -->
    <div class="search-bar">
      <el-select
        v-model="searchForm.vehicleId"
        placeholder="请选择车辆"
        style="width: 200px; margin-right: 10px"
        clearable
        filterable
      >
        <el-option label="全局内容" value="" />
        <el-option
          v-for="vehicle in vehicleList"
          :key="vehicle.vehicleId"
          :label="`${vehicle.brand} ${vehicle.model} (${vehicle.vehicleId})`"
          :value="vehicle.vehicleId"
        />
      </el-select>
      <el-select
        v-model="searchForm.contentType"
        placeholder="请选择内容类型"
        style="width: 200px; margin-right: 10px"
        clearable
      >
        <el-option label="保障说明" value="guarantee" />
        <el-option label="激活说明" value="activation" />
        <el-option label="改装说明" value="modification" />
      </el-select>
      <el-button type="primary" @click="handleSearch">搜索</el-button>
      <el-button @click="handleReset">重置</el-button>
      <el-button type="success" @click="handleAdd">新增</el-button>
    </div>
    
    <!-- 数据表格 -->
    <el-table :data="tableData" border style="width: 100%; margin-top: 20px">
      <el-table-column prop="contentId" label="内容ID" width="150" />
      <el-table-column prop="vehicleId" label="车辆" width="200">
        <template slot-scope="scope">
          <span v-if="scope.row.vehicleId">{{ getVehicleDisplayName(scope.row.vehicleId) }}</span>
          <span v-else class="global-content">全局内容</span>
        </template>
      </el-table-column>
      <el-table-column prop="contentType" label="内容类型" width="120">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.contentType === 'guarantee'" type="primary">保障说明</el-tag>
          <el-tag v-else-if="scope.row.contentType === 'activation'" type="success">激活说明</el-tag>
          <el-tag v-else-if="scope.row.contentType === 'modification'" type="warning">改装说明</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="title" label="标题" width="200" />
      <el-table-column prop="content" label="内容" show-overflow-tooltip />
      <el-table-column prop="sortOrder" label="排序" width="80" />
      <el-table-column label="操作" width="200" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    
    <!-- 分页 -->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pagination.current"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pagination.size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pagination.total"
      style="margin-top: 20px; text-align: right"
    />
    
    <!-- 新增/编辑对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="800px">
      <el-form :model="form" :rules="rules" ref="form" label-width="120px">
        <el-form-item label="车辆" prop="vehicleId">
          <el-select v-model="form.vehicleId" placeholder="请选择车辆（可选，留空表示全局内容）" style="width: 100%" clearable>
            <el-option label="全局内容" value="" />
            <el-option
              v-for="vehicle in vehicleList"
              :key="vehicle.vehicleId"
              :label="`${vehicle.brand} ${vehicle.model} (${vehicle.vehicleId})`"
              :value="vehicle.vehicleId"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="内容类型" prop="contentType">
          <el-select v-model="form.contentType" placeholder="请选择内容类型" style="width: 100%">
            <el-option label="保障说明" value="guarantee" />
            <el-option label="激活说明" value="activation" />
            <el-option label="改装说明" value="modification" />
          </el-select>
        </el-form-item>
        <el-form-item label="标题" prop="title">
          <el-input v-model="form.title" placeholder="请输入标题" />
        </el-form-item>
        <el-form-item label="内容" prop="content">
          <el-input
            v-model="form.content"
            type="textarea"
            :rows="8"
            placeholder="请输入内容"
          />
        </el-form-item>
        <el-form-item label="排序" prop="sortOrder">
          <el-input-number v-model="form.sortOrder" :min="0" style="width: 100%" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getGuaranteeContentList, addGuaranteeContent, updateGuaranteeContent, deleteGuaranteeContent } from '@/api/guarantee'
import request from '@/utils/request'

export default {
  name: 'GuaranteeContentTab',
  data() {
    return {
      searchForm: {
        vehicleId: '',
        contentType: ''
      },
      vehicleList: [],
      tableData: [],
      pagination: {
        current: 1,
        size: 10,
        total: 0
      },
      dialogVisible: false,
      dialogTitle: '新增保障说明内容',
      form: {
        vehicleId: '',
        contentType: '',
        title: '',
        content: '',
        sortOrder: 0
      },
      rules: {
        contentType: [
          { required: true, message: '请选择内容类型', trigger: 'change' }
        ],
        content: [
          { required: true, message: '请输入内容', trigger: 'blur' }
        ],
        sortOrder: [
          { required: true, message: '请输入排序', trigger: 'blur' }
        ]
      },
      isEdit: false,
      editId: null
    }
  },
  mounted() {
    this.loadVehicleList()
    this.loadData()
  },
  methods: {
    // 加载数据
    async loadData() {
      try {
        const params = {
          current: this.pagination.current,
          size: this.pagination.size,
          vehicleId: this.searchForm.vehicleId,
          contentType: this.searchForm.contentType
        }
        const response = await getGuaranteeContentList(params)
        if (response.code === '200') {
          this.tableData = response.data.records
          this.pagination.total = response.data.total
        } else {
          this.$message.error(response.msg || '获取数据失败')
        }
      } catch (error) {
        console.error('加载数据失败:', error)
        this.$message.error('网络错误，请重试')
      }
    },
    
    // 搜索
    handleSearch() {
      this.pagination.current = 1
      this.loadData()
    },
    
    // 重置
    handleReset() {
      this.searchForm.vehicleId = ''
      this.searchForm.contentType = ''
      this.pagination.current = 1
      this.loadData()
    },
    
          // 新增
      handleAdd() {
        this.isEdit = false
        this.dialogTitle = '新增保障说明内容'
        this.form = {
          vehicleId: '',
          contentType: '',
          title: '',
          content: '',
          sortOrder: 0
        }
        this.dialogVisible = true
      },
    
    // 编辑
    handleEdit(row) {
      this.isEdit = true
      this.editId = row.id
      this.dialogTitle = '编辑保障说明内容'
      this.form = { ...row }
      this.dialogVisible = true
    },
    
    // 删除
    handleDelete(row) {
      this.$confirm('确认删除该保障说明内容吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const response = await deleteGuaranteeContent(row.id)
          if (response.code === '200') {
            this.$message.success('删除成功')
            this.loadData()
          } else {
            this.$message.error(response.msg || '删除失败')
          }
        } catch (error) {
          console.error('删除失败:', error)
          this.$message.error('网络错误，请重试')
        }
      })
    },
    
    // 提交表单
    handleSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          try {
            let response
            if (this.isEdit) {
              response = await updateGuaranteeContent(this.form)
            } else {
              response = await addGuaranteeContent(this.form)
            }
            
            if (response.code === '200') {
              this.$message.success(this.isEdit ? '更新成功' : '添加成功')
              this.dialogVisible = false
              this.loadData()
            } else {
              this.$message.error(response.msg || (this.isEdit ? '更新失败' : '添加失败'))
            }
          } catch (error) {
            console.error('提交失败:', error)
            this.$message.error('网络错误，请重试')
          }
        }
      })
    },
    
    // 分页大小改变
    handleSizeChange(size) {
      this.pagination.size = size
      this.loadData()
    },
    
    // 当前页改变
    handleCurrentChange(current) {
      this.pagination.current = current
      this.loadData()
    },
    
    // 加载车辆列表
    async loadVehicleList() {
      try {
        const response = await request.get('/api/admin/guarantee/vehicle/options')
        if (response.code === '200') {
          this.vehicleList = response.data
        } else {
          this.$message.error(response.msg || '获取车辆列表失败')
        }
      } catch (error) {
        console.error('加载车辆列表失败:', error)
        this.$message.error('网络错误，请重试')
      }
    },
    
    // 获取车辆显示名称
    getVehicleDisplayName(vehicleId) {
      const vehicle = this.vehicleList.find(v => v.vehicleId === vehicleId)
      if (vehicle) {
        return `${vehicle.brand} ${vehicle.model} (${vehicle.vehicleId})`
      }
      return vehicleId
    }
  }
}
</script>

<style scoped>
.guarantee-content-tab {
  padding: 20px;
}

.search-bar {
  margin-bottom: 20px;
}

.global-content {
  color: #909399;
  font-style: italic;
}
</style> 